export default __webpack_public_path__ + "static/media/bg-1.1b8ebe2a.svg";